var _path, _path2, _path3, _rect, _rect2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 8.58691V13.0269",
    stroke: "white",
    strokeWidth: 1.45455,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0265 2.66699C11.1199 2.66699 7.14653 6.64032 7.14653 11.547V14.347C7.14653 15.2537 6.7732 16.6137 6.30653 17.387L4.6132 20.2137C3.5732 21.9603 4.2932 23.907 6.2132 24.547C12.5865 26.667 19.4799 26.667 25.8532 24.547C27.6532 23.947 28.4265 21.8403 27.4532 20.2137L25.7599 17.387C25.2932 16.6137 24.9199 15.2403 24.9199 14.347V11.547C24.9065 6.66699 20.9065 2.66699 16.0265 2.66699Z",
    stroke: "white",
    strokeWidth: 1.45455,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4405 25.0938C20.4405 27.5338 18.4405 29.5338 16.0005 29.5338C14.7872 29.5338 13.6672 29.0271 12.8672 28.2271C12.0672 27.4271 11.5605 26.3071 11.5605 25.0938",
    stroke: "white",
    strokeWidth: 1.45455,
    strokeMiterlimit: 10
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.5752,
    y: 0.969697,
    width: 8.72727,
    height: 8.72727,
    rx: 4.36364,
    fill: "#F57600"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.5752,
    y: 0.969697,
    width: 8.72727,
    height: 8.72727,
    rx: 4.36364,
    stroke: "white",
    strokeWidth: 1.93939
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.ed5b4993f7fe360f3a67b4690d75d5bc.svg";
export { ForwardRef as ReactComponent };